/**
 * 有害物質
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/hazardous_substances`

const search_hazardous_substance = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_hazardous_substance
